// Bookboost: import custom setUp instead of the one in './web-messenger'
import { setUp } from './bookboost-web-messenger';
import { IFRAME_ID } from '../../shared/js/constants/ids';

// Ensure iframe has not yet been injected
if (!document.getElementById(IFRAME_ID)) {
    setUp();

    // Bookboost: disabled this since we have our own loader and api and don't
    //            want to expose the WebMessenger object to our users. All
    //            interaction is instead done with our api e.g. `bb('open')`.
    // if (window.__onWebMessengerHostReady__) {
    //     window.__onWebMessengerHostReady__(WebMessenger);
    // } else if (GLOBAL_VAR_NAME) {
    //     // Script loader wasn't found, host bundle is being used on its own.
    //     global[GLOBAL_VAR_NAME] = WebMessenger;
    // }
}
